module.exports = __webpack_public_path__ + "img/fig14.42838b65.jpg";